import React, { useEffect } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    HStack,
    Box,
    Text,
    Spacer,
    Stack,
    Flex,
    Image,
    TableContainer,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,

} from '@chakra-ui/react'
import SraList from './SraList'
import moment from 'moment/moment'
import { GrAttachment } from 'react-icons/gr'
import { BsArrowDownCircleFill, BsArrowUpCircleFill, BsFillCloudUploadFill } from 'react-icons/bs'
import Input from './Input'
import { useState } from 'react'
import Button from './Button'
import { UploadInvoice, UploadWaybillFile } from '../Utils/ApiCalls'
import { local } from '../Utils/ApiConfig'
import { typeStore } from '../Utils/Helpers'
import TableRow from './TableRow'
import { AiFillPrinter } from 'react-icons/ai'



export default function BinShelfModal({ isOpen, onClose, singleData }) {

    console.log("singleData", singleData)

    const [Hide, setHide] = useState(false);


    const printNow = () => {
        setHide(true)

        setTimeout(() => {
            window.print(1)

        }, 1000);
        setTimeout(() => {
            setHide(false)


        }, 2000);
    }




    useEffect(() => {

    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"full"}>
            <ModalOverlay />
            <ModalContent>
                {/* <ModalHeader>Bin Card for {singleData[0]?.productname}</ModalHeader> */}

                {
                    !Hide && (

                        <ModalCloseButton />
                    )
                }
                <ModalBody>

                    <HStack mt={"42px"}>
                        <Image src='/logo.jpg' width={"10%"} />
                        <Spacer />
                        {
                            !Hide && (

                                <HStack fontSize={"20px"} cursor="pointer" onClick={printNow}>
                                    <Box><AiFillPrinter /></Box>
                                    <Text color="#fff" bgColor="navy" fontSize={"14"} px="8px" py="3px" rounded="8px">Print</Text>
                                </HStack>
                            )
                        }
                    </HStack>
                    <Text mt="10px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Ims Bin Card</Text>
                    <Stack spacing={"20px"} mt={"42px"}>
                        <HStack>
                            <SraList title={"MAXIMUM : "} details={singleData[0]?.productkey.maximum} />
                            <Spacer />
                            <SraList title={"VOCAB NO: "} details={singleData[0]?.productkey.productshelfid} />
                        </HStack>
                        <HStack>
                            <SraList title={"MINIMUM: "} details={singleData[0]?.productkey.minimum} />
                            <Spacer />
                            <SraList title={"RE-ORDER: "} details={singleData[0]?.productkey.reorder} />
                        </HStack>
                        <HStack>
                            <SraList title={"DESCRIPTION: "} details={"Bin Card for " + singleData[0]?.productname} />

                        </HStack>



                    </Stack>


                    <TableContainer mt="32px" overflowX="auto" color="#fff">

                        <Table variant='simple' size='sm'>
                            <Thead>
                                <Tr >
                                    <Th color="#000">S/N</Th>
                                    <Th color="#000">Date Receipt issue</Th>
                                    <Th color="#000">Reference</Th>
                                    <Th color="#000">Station</Th>
                                    <Th color="#000">In</Th>
                                    <Th color="#000">Out</Th>
                                    <Th color="#000">Balance</Th>


                                </Tr>
                            </Thead>
                            <Tbody>

                                {
                                    singleData?.map((item, i) => (

                                        <TableRow
                                            key={i}
                                            type={"binCardRow"}
                                            color='#242424'
                                            sn={i + 1}
                                            dateReceived={moment(item.recievedissuedate).format("DD/MM/YYYY")}
                                            reference={item.reference}
                                            inn={item.qtyin}
                                            out={item.qtyout}
                                            balance={item.balance}

                                        />
                                    ))
                                }

                            </Tbody>

                        </Table>
                    </TableContainer>


                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
